import React from "react";

function ReviewSubmit({ onBack, onSubmit, formData }) {
  return (
    <div>
      <h2>Review & Submit</h2>
      <pre>{JSON.stringify(formData, null, 2)}</pre>
      <br />
      <button onClick={onBack}>⬅️ Back</button>
      <button onClick={onSubmit}>✅ Submit to Mercury (via Zap)</button>
    </div>
  );
}

export default ReviewSubmit;
